import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopGym = dynamic(() => import('../../components/spa-salon/gym/DesktopGym'), {
  loading: () => <Loading />,

});
const MobileGym = dynamic(() => import('../../components/spa-salon/gym/MobileGym'), {
  loading: () => <Loading />,

});

const gymPOSBillingSoftware = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Fitness Center POS Billing Software | Best Gym POS Solutions</title>
        <link rel="canonical" href="https://queuebuster.co/spa-and-salon/gym-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/spa-and-salon/gym-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Discover the best fitness center POS billing software to streamline your operations. Enhance your gym with top management and billing solutions." />
        <meta property="og:title" content="Fitness Center POS Billing Software | Best Gym POS Solutions" />
        <meta property="og:description" content="Discover the best fitness center POS billing software to streamline your operations. Enhance your gym with top management and billing solutions." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/gym.jpg" />
        <meta property="og:url" content="https://queuebuster.co/spa-and-salon/gym-pos-billing-software" />

      </Head>
         <SchemaTags page="gym-pos-billing-software" />
      {
        mobileView ? <MobileGym /> : <DesktopGym />
      }
    </>
  )
}

export default gymPOSBillingSoftware